import React, { useEffect, useState } from "react";
import PdfViewer from "./PdfViewer";
import PatientForm from "../PatientForm";
import { API } from "../../services/api";

export default function OrdonnanceModal({ ordonnance, draft, setDraft, onClose, medicamentStrategy, commande, onSave, isDirty }) {
    const [blobUrl, setBlobUrl] = useState(null);
    const [loading, setLoading] = useState(false);
    const [fetchError, setFetchError] = useState(null);

    useEffect(() => {
        if (!ordonnance?.id) return;

        let objectUrl = null;
        setLoading(true);
        setFetchError(null);
        setBlobUrl(null);

        API.get(`/ordonnances/${ordonnance.id}/content`, { responseType: "blob" })
            .then(response => {
                objectUrl = URL.createObjectURL(response.data);
                setBlobUrl(objectUrl);
            })
            .catch(() => setFetchError("Impossible de charger le fichier."))
            .finally(() => setLoading(false));

        return () => {
            if (objectUrl) URL.revokeObjectURL(objectUrl);
        };
    }, [ordonnance?.id]);

    if (!ordonnance) return null;

    return (
        <div
            style={{
                position: "fixed",
                inset: 0,
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                zIndex: 1000
            }}
        >
            <button type="button" aria-label="Fermer l'ordonnance" onClick={onClose} style={{ position: "absolute", inset: 0, border: 0, background: "rgba(0,0,0,0.6)" }} />
            <dialog
                open
                aria-label={ordonnance.name || "Ordonnance"}
                onKeyDown={event => { if (event.key === "Escape") onClose(); }}
                style={{
                    position: "relative",
                    margin: 0,
                    padding: 0,
                    border: 0,
                    width: "90%",
                    height: "90%",
                    background: "white",
                    borderRadius: "10px",
                    display: "flex",
                    flexDirection: "column",
                    overflow: "hidden"
                }}
            >

                {/* PDF — haut */}
                <div style={{ flex: 3, minHeight: 0, display: "flex", alignItems: "center", justifyContent: "center" }}>
                    {loading && (
                        <p style={{ color: "#666" }}>Chargement...</p>
                    )}
                    {fetchError && (
                        <p style={{ color: "#c62828", padding: "20px" }}>{fetchError}</p>
                    )}
                    {!loading && !fetchError && blobUrl && (
                        <PdfViewer url={blobUrl} fileName={ordonnance.name} />
                    )}
                    {!loading && !fetchError && !blobUrl && (
                        <p style={{ color: "#888", padding: "20px" }}>Aucun fichier</p>
                    )}
                </div>

                {/* Édition patients — bas */}
                <div style={{
                    flex: 2,
                    minHeight: 0,
                    padding: "12px 16px",
                    borderTop: "1px solid #ddd",
                    overflowY: "auto"
                }}>
                    <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: "8px" }}>
                        <strong style={{ fontSize: "13px", color: "#334155" }}>{ordonnance.name || "Fichier"}</strong>
                        <button
                            onClick={onClose}
                            style={{ background: "none", border: "none", cursor: "pointer", fontSize: "16px", color: "#64748b" }}
                        >✕</button>
                    </div>

                    {draft && setDraft ? (
                        <PatientForm
                            patients={draft?.patients || []}
                            ehpadId={draft?.ehpadId}
                            onChange={(patients) =>
                                setDraft(prev => ({ ...prev, patients }))
                            }
                            medicamentStrategy={medicamentStrategy}
                            commande={commande}
                            onSave={onSave}
                            isDirty={isDirty}
                        />
                    ) : (
                        <div style={{ padding: "24px", textAlign: "center", color: "#94a3b8", fontSize: "13px" }}>
                            Ouvrez la commande depuis la gestion pour modifier les patients.
                        </div>
                    )}
                </div>

            </dialog>
        </div>
    );
}
